import { Swiper, SwiperSlide } from 'swiper/react';
import SectionTitle from '../../../../components/SectionTitle';
import style from './Approach.module.scss';
import approachSlides from './slides';
import Slide from './components/Slide';
import { Navigation, Pagination } from 'swiper/modules';
import { useRef } from 'react';
import './slider.scss';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import { Fade } from 'react-reveal';
import { useIntersectionObserver, useMediaQuery } from 'usehooks-ts';

const ApproachSection = () => {
  const isMobile = useMediaQuery('(max-width:991px)');
  const prevNavBtn = useRef(null);
  const nextNavBtn = useRef(null);
  const paginationRef = useRef(null);

  const ref = useRef(null);
  const entry = useIntersectionObserver(ref, {});
  const isVisible = !!entry?.isIntersecting;

  const pagination = {
    enabled: true,
    clickable: true,
    el: `#approach-slider-pagination`,
    renderBullet: function (index, className) {
      return `<span class="${`${style.approachNavigation__num} approach-navigation__num ${className} `}">0${
        index + 1
      }</span>`;
    },
  };

  return (
    <section ref={ref} className={style.approach}>
      <div className='container'>
        <SectionTitle className={style.approach__title}>
          Our
          <br />
          <span>Approach</span>
        </SectionTitle>
        <Fade spy={isVisible} bottom>
          <Swiper
            modules={[Navigation, Pagination]}
            spaceBetween={50}
            slidesPerView={1}
            // autoHeight={true}
            allowTouchMove={isMobile}
            navigation={{
              enabled: true,
              prevEl: '#approach-slider-nav-prev',
              nextEl: '#approach-slider-nav-next',
            }}
            pagination={pagination}
            className={`${style.approachSlider} approach-slider-home`}
          >
            {approachSlides.map((item, index) => (
              <SwiperSlide key={index}>
                <Slide
                  title={item.title}
                  descr={item.descr}
                  video={item.videoSrc}
                  to={item.to}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </Fade>
        <Fade spy={isVisible} bottom>
          <div className={style.approachNavigation}>
            <span
              id='approach-slider-nav-prev'
              ref={prevNavBtn}
              className={style.approachNavigation__btn}
            >
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M10.3077 17.3077L11.0154 16.5884L6.92693 12.5H19V11.5H6.92693L11.0154 7.41151L10.3077 6.69226L5 12L10.3077 17.3077Z'
                  fill='#C4DBE0'
                />
              </svg>
            </span>
            <div
              className={style.approachNavigation__list}
              id='approach-slider-pagination'
              ref={paginationRef}
            ></div>
            <span
              id='approach-slider-nav-next'
              ref={nextNavBtn}
              className={style.approachNavigation__btn}
            >
              <svg
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
                xmlns='http://www.w3.org/2000/svg'
              >
                <path
                  d='M13.6923 17.3077L12.9846 16.5884L17.0731 12.5H5V11.5H17.0731L12.9846 7.41151L13.6923 6.69226L19 12L13.6923 17.3077Z'
                  fill='#C4DBE0'
                />
              </svg>
            </span>
          </div>
        </Fade>
      </div>
    </section>
  );
};

export default ApproachSection;
